import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { OfficeEditor } from "../../Office/OfficeEditor";
import { _CashDeskAccountCDP } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { CashDeskAccountSelector } from "../CashDeskAccountSelector";
import { CompanyEditor } from "../../Company/CompanyEditor";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { CDPsEditor } from "../../../../contabilidad/budgetRPFactory/CDPsEditor";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { ErrorList } from "../../../../theme/Component/ErrorList";


interface Props {
    CashDeskAccountCDPIDDocument: any;
    // CashDeskAccountCDPDocumentDate: any;
    onChange?: Function;
}


export const CashDeskAccountCDPCertificate = ({ CashDeskAccountCDPIDDocument, onChange }: Props) => {

    const cashdeskaccountcdp = useDataBean(_CashDeskAccountCDP);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [response, setResponse] = useState<any>({});
    const [msgList, setMsgList] = useState<any>([]);
    const [tap, setTap] = useState<number>(0);
    useEffect(() => {

    }, [CashDeskAccountCDPIDDocument])
    // useEffect(() => {
    //     onChange({
    //         Response: response,
    //         Documents: lista,
    //         MSGList: msgList,
    //     })
    // }, [lista, msgList])

    const getLista = () => {

        cashdeskaccountcdp.instance.getAccountantDocumentByLocation(CashDeskAccountCDPIDDocument.IDDocument, CashDeskAccountCDPIDDocument.Since).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp.DocumentURL)
                    setResponse(resp)
                    setMsgList(resp.MsgList);
                    setTap(1)
                    console.log(resp)
                }
            }
        )

    }


    const deleteItem = () => {
        cashdeskaccountcdp.deleteItemVoid(cashdeskaccountcdp.bean.IDCashDeskAccountCDP).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }


    const head = [
        { title: 'ID', property: 'IDCashDeskAccountCDP', visible: true },





    ]


    const listaBotones = () => {
        const botones = [


            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Certificados de Disponibilidad Presupuestal de Cajas Menores">

            {/* <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={cashdeskaccountcdp.setBean} listButtons={listaBotones()}></BasicTable>
                    <DocumentViewer list={lista} />
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div> */}

            <div className="row">
                {tap === 0 &&
                    <div className="col-md-12">
                        <BasicButton icon="ri-article-line" eventClick={getLista}>Ver Certificado</BasicButton>
                    </div>
                }
                {tap === 1 &&
                    <div className="col">
                        {msgList.length > 0 &&
                            <ErrorList lista={msgList} />
                        }
                        {msgList.length === 0 && lista.length > 0 &&
                            <DocumentViewer key={lista} list={lista} />
                        }
                    </div>
                }
            </div>
        </BasicPage>
    )
}